<template>
  <scroll-center-dialog
      v-model="opened"
      :loading="save_loading"
      width="760" @close="close"
      @apply="save"
      :title="form_title"
      :scrolled="false"
  >
    <div v-if="!loading">
      <OrderVisitors
          :disabled="this.edit"
          class="pt-4"
          :key="0+'visitor'"
          :item="regularPass_visitors[0]"
          :index="0"
          :organizations="organizations_selector"
          :visitors="selectors.visitors"
          :user_selector="user_selector"
          :add-visitor.sync="add_visitors"
          :order-visitors.sync="regularPass_visitors"
          :special-error.sync="special_error"
          :visitor_error="visitor_error"
          :order-type="5"
      >
      </OrderVisitors>
      <template
          v-for="(item, i) in regularPass.territories"
      >
        <Territories
            :key="i+'uid'"
            :item="item"
            :index="i"
            :territories="regularPass.territories"
            :selectors="selectors.territories"
            :special-error.sync="territories_error"
        >
        </Territories>
      </template>
      <v-row no-gutters class="pa-0">
        <v-spacer></v-spacer>
        <v-btn
            text
            @click="addNewTerritory"
            class="pr-0"
        >
          Добавить территорию
          <v-icon>add</v-icon>
        </v-btn>
      </v-row>
      <v-text-field
          v-model="regularPass.justification"
          label="Обоснование"
          outlined
          :error="hasError('justification')"
          :errorMessages="getError('justification')"
      ></v-text-field>
      <v-row justify="space-between" align="center"
             v-if="edit && regularPass.attached_file && !regularPass.attached_file?.name" no-gutters
             class="border-md rounded mb-2">
        <v-col cols="auto" class="pa-4">
          Файл: <a target="_blank" :href="regularPass.attached_file">Загруженный файл</a>
        </v-col>
        <v-col cols="auto">
          <v-tooltip location="bottom" text="Заменить файл">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" class="mr-4 opacity-60" @click="regularPass.attached_file = undefined">cancel
              </v-icon>
            </template>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-file-input
          v-else
          v-model="regularPass.attached_file"
          label="Файл"
          outlined
          :multiple="false"
          :error="hasError('attached_file')"
          :error-messages="getError('attached_file')"
      >
      </v-file-input>
      <!--      <v-file-input-->
      <!--          v-model="regularPass.attached_file"-->
      <!--          label="Файл"-->
      <!--          outlined-->
      <!--          :error="hasError('attached_file')"-->
      <!--          :errorMessages="getError('attached_file')"-->
      <!--      >-->
      <!--      </v-file-input>-->
      <v-autocomplete
          v-if="!add_car"
          outlined
          ref="cars-autocomplete"
          v-model="regularPass.car"
          :items="selectors.cars"
          label="Автомобиль"
          :error="hasError('car')"
          :errorMessages="getError('car')"
      >
        <template v-slot:label>
          Автомобиль <strong class="red--text">*</strong>
        </template>
        <template v-slot:prepend-item>
          <v-btn
              block
              elevation="0"
              text
              @click="addNewCar"
          >
            <v-icon>add</v-icon>
            Добавить новый автомобиль
          </v-btn>
        </template>
      </v-autocomplete>
      <v-card
          v-if="add_car"
          class="pa-4 pb-0 mb-5"
          color="grey lighten-3"
      >
        <v-card-title class="pa-0 pb-4">
          Добавление автомобиля:
          <v-spacer></v-spacer>
          <v-btn
              fab
              icon
              small
              @click="closeAddCar"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-row no-gutters class="pa-0">
          <v-col cols="12" md="6" class="pr-md-1">
            <v-text-field
                ref="new-car-number"
                v-model="create_car.number"
                outlined
                :error="hasError('car.number')"
                :error-messages="getError('car.number')"
            >
              <template v-slot:label>
                Номер <strong class="red--text">*</strong>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pr-md-1">
            <loading-autocomplete
                placeholder="Введите название и выберете из предложенных вариантов"
                outlined
                v-model="create_car.model"
                search-parameter="search"
                :url="car_selector"
                :error="hasError('car.model')"
                :error-messages="getError('car.model')"
                :item-text="getText"
                :load-fios="false"
            >
              <template v-slot:label>
                Марка <strong class="red--text">*</strong>
              </template>
              <template v-slot:no-data>
                <div class="px-4">
                  Для поиска начните набирать название, <br> и подождите 1 секунду, либо нажмите Enter
                </div>
              </template>
            </loading-autocomplete>
          </v-col>
        </v-row>
      </v-card>
      <v-alert outlined rounded :icon="'priority_high'" v-if="hasError('non_field_errors') " type="error">
        {{ getError('non_field_errors')[0] }}
      </v-alert>
    </div>
    <div class="action mt-8 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import selectors from "@/urls/selectors";
import OrderVisitors from "@/modules/templates/OrderVisitors.vue";
import {SemipolarSpinner} from "epic-spinners";
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete.vue";
import Territories from "@/modules/entitled/regularpasses/modals/Territories.vue";

export default {
  name: "RegularPassesEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    regularPassData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    Territories,
    ScrollCenterDialog,
    OrderVisitors,
    LoadingAutocomplete,
    SemipolarSpinner
  },
  data() {
    return {
      loading: false,
      save_loading: false,
      regularPass_default: {
        car: null,
        visitor: {},
        justification: null,
        attached_file: null,
        territories: [{
          uid: {}
        }]
      },
      add_car: false,
      regularPass: undefined,
      selectors: {
        cars: [],
        visitors: [],
        territories: []
      },
      create_car: {
        number: "",
        model: ""
      },
      add_visitors: [
        {
          visitor: false,
          portal_user: false
        }
      ],
      regularPass_visitors: [
        {visitor_id: undefined}
      ],
      special_error: [],
      visitor_error: [],
      territories_error: []
    }
  },
  watch: {
    regularPass: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
      },
      deep: true
    },
    regularPass_visitors: {
      handler: function () {
        this.visitor_error = []
        this.special_error = []
        this.territories_error = []
      },
      deep: true
    }
  },
  computed: {
    form_title() {
      return this.edit === false ? "Добавить постоянный пропуск" : "Редактировать постоянный пропуск"
    },
    organizations_selector() {
      return selectors.SELECTORS.VISITORS.ORGANIZATIONS()
    },
    user_selector() {
      return selectors.SELECTORS.USERS.ALL()
    },
    car_selector() {
      return selectors.SELECTORS.CARS.MODELS()
    }
  },
  methods: {
    ...mapActions({
      createRegularPass: "entitled/createRegularPasses",
      changeRegularPass: "entitled/changeRegularPasses",
      loadCarsSelector: "selectors/loadCarsSelector",
      loadUsersVisitorsSelector: "selectors/loadUsersVisitorsSelector",
      loadTerritoriesSelector: "selectors/loadTerritoriesSelector",
      loadRegularPassesDetail: "entitled/loadRegularPassesDetail"
    }),
    close() {
      this.$emit("close", false)
    },
    getText(value) {
      if (value !== undefined)
        return `${value.text}`
      else
        return ""
    },
    loadSelectors() {
      this.loadCarsSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.cars = val
        }
      })
      this.loadTerritoriesSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.territories = val
        }
      })
      this.loadUsersVisitorsSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.visitors = val
        }
      })
    },
    // Добавление еще одной территории
    addNewTerritory() {
      this.regularPass.territories.push({
        uid: {}
      })
    },
    loadRegularPassData() {
      this.loading = true
      if (this.regularPassData === undefined) {
        this.regularPass = this.regularPass_default
        this.loading = false
      } else {
        this.regularPass = JSON.parse(JSON.stringify(this.regularPassData))
        // Загрузка данных при редактировании из детальки, чтобы получить авто и посетителей
        this.loadRegularPassesDetail({
          url: undefined,
          id: this.regularPass.id,
          finalizer: (data) => {
            this.regularPass.car = data.car.id
            if (!this.regularPass.territories)
              this.regularPass.territories = []
            // Преобразование посетителей перед выводом в форме
            this.regularPass_visitors = []
            this.add_visitors = []
            this.regularPass_visitors.push(data.visitor)
            this.add_visitors.push({visitor: true, portal_user: false})
            this.loading = false
          }
        })
      }
    },
    addNewCar() {
      this.add_car = true
      this.$nextTick(() => {
        this.$refs["new-car-number"].focus();
        this.$refs["new-car-number"].inputMode;
      })
    },
    closeAddCar() {
      this.add_car = false
      this.create_car = {
        number: "",
        model: ""
      }
      this.$nextTick(() => {
        this.$refs["cars-autocomplete"].focus();
        this.$refs["cars-autocomplete"].isMenuActive = true;
      })
    },
    save() {
      this.save_loading = true
      let data = {}
      // Преобразования автомобиля перед отправкой данных
      if (this.create_car.number.length > 0) {
        data.car = this.create_car
      } else if (this.regularPass.car !== undefined && typeof this.regularPass.car === "number") {
        let id = this.regularPass.car
        data.car = {id: id}
      }
      // Преобразования списка посетителей перед отправкой данных
      // Проверка на пустоту, проверка на пустое значение
      if (this.regularPass_visitors.length > 0) {
        // Присваиваем значения исходных массивов временным
        let tempArrayAddVisitor = []
        let tempArrayVisitor = this.regularPass_visitors
        // Фильтруем массив посетителей от пустых полей
        this.regularPass_visitors = this.regularPass_visitors.filter(item => Object.keys(item).length)
        this.regularPass_visitors = this.regularPass_visitors.filter(item => item.user || item.visitor_id || item.last_name)
        // Сравниваем исходных с отфильтрованным массивом и фильтруем массив булей
        for (let i in tempArrayVisitor) {
          for (let j in this.regularPass_visitors) {
            if (tempArrayVisitor[i] === this.regularPass_visitors[j]) {
              tempArrayAddVisitor.push(this.add_visitors[i])
            }
          }
        }
        this.add_visitors = tempArrayAddVisitor
        // Кладем данные, который идут на отправку
        data.visitor = this.regularPass_visitors[0]
        data.attached_file = this.regularPass.attached_file
        data.justification = this.regularPass.justification
        // Если после фильтрации наш массив остался пустой, то возвращаем его в исходное состояние
        if (this.regularPass_visitors.length === 0) {
          data.visitor = {}
          this.regularPass_visitors = [{visitor_id: undefined}]
          this.add_visitors = [{
            visitor: false,
            portal_user: false
          }]
        }
      }
      // Проверка на пустоту, проверка на пустое значение
      if (this.regularPass.territories.length > 0) {
        data.territories = []
        for (let i in this.regularPass.territories) {
          data.territories.push(this.regularPass.territories[i].uid)
        }
      }
      let formData = new FormData()
      for (let key in data) {
        if (data[key]) {
          if (key === "visitor" || key === "territories" || key === "car") {
            formData.append(key, JSON.stringify(data[key]))
          } else if (key === "attached_file" || typeof data[key] === "object") {
            formData.append(key, data[key])
          } else {
            formData.append(key, data[key])
          }
        }
      }
      if (this.edit) {
        this.changeRegularPass({
          id: this.regularPass.id,
          data: formData,
          finalizer: () => {
            this.$emit("close", this.regularPass)
            this.save_loading = false
          },
          catcher: (val) => {
            if (val.visitor) {
              this.visitor_error = [val.visitor]
              this.special_error = [val.visitor]
            }
            if (val.territories) {
              this.territories_error.push({"territories": val.territories})
            }
            if (val.non_field_errors) {
              val.non_field_errors = ["Значения в полях автомобиль и посетитель должны быть уникальными."]
            }
            if (Error.isError(val)) {
              val.non_field_errors = ['Ваш файл не должен превышать 15МБ']
            }
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      } else {
        this.createRegularPass({
          data: formData,
          finalizer: () => {
            this.$emit("close", this.regularPass)
            this.save_loading = false
          },
          catcher: (val) => {
            if (val.visitor) {
              this.visitor_error = [val.visitor]
              this.special_error = [val.visitor]
            }
            if (val.territories) {
              this.territories_error.push({"territories": val.territories})
            }
            if (val.non_field_errors) {
              val.non_field_errors = ["Значения в полях автомобиль и посетитель должны быть уникальными."]
            }
            if (Error.isError(val)) {
              val.non_field_errors = ['Ваш файл не должен превышать 15МБ']
            }
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    }
  },
  created() {
    this.loadRegularPassData()
    this.loadSelectors()
  }
}
</script>

<style scoped>

</style>
